/**
 * Lehký quick-add sheet — otevře se z [data-kloki-lqa] JSON.
 * Po přidání: KlokiCart (fail-open na /cart).
 */
(function () {
  var STRAP_COLORS = {
    'Černá': '#1d1d1d', 'Černé': '#1d1d1d',
    'Růžová': '#F2A0C4', 'Růžové': '#F2A0C4',
    'Modrá': '#33A3FF', 'Modré': '#33A3FF',
    'Zelená': '#26A455', 'Zelené': '#26A455',
    'Fialová': '#8B5CF6', 'Fialové': '#8B5CF6',
    'Oranžová': '#FF8A26', 'Oranžové': '#FF8A26',
    'Bílá': '#F4F4F4', 'Bílé': '#F4F4F4',
    'Žlutá': '#FFD43B', 'Žluté': '#FFD43B',
    'Duhová': 'linear-gradient(135deg,#ff6b6b,#ffd43b,#51cf66,#339af0,#cc5de8)',
    'Neonově růžová': '#FF4DC4'
  };

  function parseData(el) {
    var raw = el.getAttribute('data-kloki-lqa');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function init() {
    var popup = document.getElementById('kloki-lqa');
    if (!popup || popup.__klokiLqa) return;
    popup.__klokiLqa = true;

    var optsWrap = popup.querySelector('[data-kloki-lqa-opts]');
    var titleEl = popup.querySelector('#kloki-lqa-title');
    var promptEl = popup.querySelector('[data-kloki-lqa-prompt]');
    var optionLabelEl = popup.querySelector('[data-kloki-lqa-option-label]');
    var priceEl = popup.querySelector('[data-kloki-lqa-price]');
    var errorEl = popup.querySelector('[data-kloki-lqa-error]');
    var addBtn = popup.querySelector('[data-kloki-lqa-add]');
    var detailEl = popup.querySelector('[data-kloki-lqa-detail]');
    var state = { data: null, variantId: null, opener: null };

    function paintActive(activeEl) {
      Array.prototype.forEach.call(optsWrap.children, function (c) {
        c.classList.toggle('is-active', c === activeEl);
      });
    }

    function syncAdd() {
      if (addBtn) addBtn.disabled = !state.variantId;
    }

    function selectVariant(v, btn) {
      state.variantId = v && v.available ? v.id : null;
      if (btn) paintActive(btn);
      if (priceEl) priceEl.textContent = (v && v.price) || (state.data && state.data.price) || '';
      syncAdd();
    }

    function makeOpt(v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kloki-lqa__opt';
      if (v.image) {
        var img = document.createElement('img');
        img.className = 'kloki-lqa__thumb';
        img.src = v.image;
        img.alt = '';
        img.width = 36;
        img.height = 36;
        img.loading = 'lazy';
        b.appendChild(img);
      } else {
        var dot = document.createElement('span');
        dot.className = 'kloki-lqa__dot';
        var color = STRAP_COLORS[v.title] || '#cfd8e3';
        if (color.indexOf('gradient') !== -1) dot.style.background = color;
        else dot.style.backgroundColor = color;
        b.appendChild(dot);
      }
      b.appendChild(document.createTextNode(v.title));
      if (!v.available) b.disabled = true;
      b.addEventListener('click', function () {
        selectVariant(v, b);
      });
      return b;
    }

    function renderOpts() {
      optsWrap.innerHTML = '';
      state.variantId = null;
      var variants = (state.data && state.data.variants) || [];
      variants.forEach(function (v) {
        var b = makeOpt(v);
        optsWrap.appendChild(b);
        if (state.variantId === null && v.available) {
          selectVariant(v, b);
          b.classList.add('is-active');
        }
      });
      syncAdd();
    }

    function openPopup(data, opener) {
      state.data = data;
      state.opener = opener || null;
      if (titleEl) titleEl.textContent = data.title || '';
      if (promptEl) promptEl.textContent = data.prompt || '';
      if (optionLabelEl) {
        optionLabelEl.textContent = data.optionLabel || '';
        optionLabelEl.hidden = !data.optionLabel;
      }
      if (errorEl) errorEl.hidden = true;
      if (addBtn) {
        addBtn.textContent = addBtn.getAttribute('data-label-add') || addBtn.textContent;
        addBtn.disabled = true;
      }
      if (detailEl) {
        detailEl.href = data.url || '#';
        detailEl.hidden = !data.url;
      }
      renderOpts();
      if (popup.parentElement !== document.body) document.body.appendChild(popup);
      popup.hidden = false;
      document.documentElement.classList.add('kloki-lqa-open');
      var closeBtn = popup.querySelector('.kloki-lqa__close');
      if (closeBtn) closeBtn.focus();
    }

    function closePopup() {
      popup.hidden = true;
      document.documentElement.classList.remove('kloki-lqa-open');
      if (state.opener && state.opener.focus) state.opener.focus();
    }

    popup.querySelectorAll('[data-kloki-lqa-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !popup.hidden) closePopup();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!state.variantId) return;
        if (errorEl) errorEl.hidden = true;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-adding') || addBtn.textContent;

        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: state.variantId, quantity: 1 })
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw new Error(data.description || data.message || ('HTTP ' + r.status));
              return data;
            });
          })
          .then(function () {
            closePopup();
            if (window.KlokiCart && typeof window.KlokiCart.open === 'function') {
              if (typeof window.KlokiCart.invalidateCart === 'function') {
                window.KlokiCart.invalidateCart();
              }
              window.KlokiCart.open();
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () {
            if (errorEl) errorEl.hidden = false;
          })
          .finally(function () {
            addBtn.disabled = !state.variantId;
            addBtn.textContent = addBtn.getAttribute('data-label-add') || addBtn.textContent;
          });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kloki-lqa]');
      if (!btn) return;
      var data = parseData(btn);
      if (!data || !data.variants || !data.variants.length) return;
      e.preventDefault();
      openPopup(data, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
